import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { WorkspaceSliceDTO } from './types'

export const WORKSPACE_FRAGMENT_FOR_GLOBAL_SETUP_GENERAL = (
  ability: Ability,
): TypedDocumentNode<WorkspaceSliceDTO> => gql`
  fragment WorkspaceFragmentForGeneralSetupGeneral on Workspace {
    ${permitFields({
      priceGeniusAlwaysOn: ability.can('read', 'GlobalSetupField-priceGenius'),
    })}

    id
    name
  }
`
